import type { InlineTaskFormValues } from '~/app/components/maintenance/preventive/wizard/StepTasks/types';
import type { WizardTask } from '~/app/components/maintenance/preventive/wizard/types';
import { toSubtaskPayload } from '~/app/components/maintenance/TaskSubtasksField/TaskSubtasksField';
import type { CreateTaskBody } from '~/app/services/preventive-maintenance/preventive-maintenance.service';

export const LATEST_TASK_SUGGESTION_COUNT = 5;

export function wizardTasksHaveTriggers(tasks: readonly WizardTask[]): boolean {
  return tasks.length > 0 && tasks.every((task) => Boolean(task.triggerId));
}

export function takeLatestTaskSuggestions<T>(
  items: readonly T[],
  count = LATEST_TASK_SUGGESTION_COUNT,
): T[] {
  return items.slice(0, count);
}

/** Maps wizard inline task form values to the create-task API body (incl. partIds + subtasks). */
export function toInlineCreateTaskRequest(
  values: InlineTaskFormValues,
): CreateTaskBody {
  return {
    name: values.name,
    workTypeId: values.workTypeId,
    mandatory: values.mandatory ?? true,
    requiresShutdown: values.requiresShutdown ?? false,
    estimatedDurationMinutes: values.estimatedDurationMinutes ?? null,
    partIds: values.partIds ?? [],
    subtasks: toSubtaskPayload(values.subtasks),
  };
}
